import React from 'react';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import GroupAddRoundedIcon from '@mui/icons-material/GroupAddRounded';

/**
 * Vezes que o jogador completou um time nesta pelada. Na hora de completar, tem a vez quem completou menos;
 * empate pela ordem de chegada (API: partidaController.completarTime).
 */
const CompletouChip = ({ vezes }) => {
  if (!vezes) return null;
  return (
    <Tooltip title={`Completou um time ${vezes === 1 ? '1 vez' : `${vezes} vezes`} nesta pelada. Na próxima, a vez é de quem completou menos.`} enterTouchDelay={0}>
      <Chip
        size="small"
        icon={<GroupAddRoundedIcon />}
        label={`${vezes}x`}
        aria-label={`Completou ${vezes} ${vezes === 1 ? 'vez' : 'vezes'}`}
        sx={{ flexShrink: 0, fontWeight: 700, '& .MuiChip-icon': { fontSize: 16 } }}
      />
    </Tooltip>
  );
};

export default CompletouChip;
